<template>
  <v-sheet>
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          label="تلفن همراه *"
          v-model="mobilePhoneNumber"
          type="number"
          outlined
          dense
          required
          :rules="[
            (v) =>
              (!!v && v.length == 10 && v.substring(0, 1) == '9') ||
              'شماره همراه بصورت عدد و بدون صفر شروع شود .',
          ]"
          counter="10"
        />
        <v-btn @click="AddPermittedUserPhone()">ثبت</v-btn>
      </v-col>
      <v-col cols="12" md="6" class="mr-6">
        <h4>لیست مجوزهای موجود</h4>
        <ul
          v-for="ph in permittedList"
          style="list-style-type: none; font-weight: 900"
        >
          <li>
            <v-btn tag="div" @click="getUserInfoByPhone(ph)">
              {{ ph }}
            </v-btn>

            <v-btn v-if="ownerUserPhone != ph" @click="removePermittedUser(ph)"
              >حذف</v-btn
            >
          </li>
        </ul>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-dialog v-model="showUserInfo" max-width="300">
          <v-card class="mx-auto" max-width="300" hover>
            <v-card-item>
              <v-card-title>
                {{ userInfo.fullName }}
              </v-card-title>

              <v-card-subtitle>
                <span>{{ userInfo.phoneNumber }}</span>
              </v-card-subtitle>
            </v-card-item>

            <v-card-text>
              <span>شماره همراه : {{ userInfo.phoneNumber }} </span>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-sheet>
</template>
<script>
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import { RepoFactory } from '@/baseRepository/Factory';
const merchantRepository = () => RepoFactory.get('merchant');
const authRepository = () => RepoFactory.get('auth');
import Helper from '@/core/helpers';
 
import Swal from 'sweetalert2';
export default {
  mixins: [asyncLoadMixin, reusableMethodsMixin],
  props: {
    merchantId: {
      type: String,
      default: null,
    },
    ownerPhoneNumber: {
      type: String,
      default: null,
    },
    merchantIsApproved: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mobilePhoneNumber: null,
      permittedList: [],
      ownerUserPhone: null,
      userBusinessInformation: null,
      userInfo: {},
      showUserInfo: false,
    };
  },
  created() {
    this.getPermittedUsersData();
    if (this.merchantIsApproved) {
      //  this.getMerchantInformation();
      this.getSupplierInformation();
    } else {
      this.getSupplierInformation();
    }
  },
  watch: {
    merchantId(after) {
      if (after) this.getPermittedUsersData();
    },
  },
  computed: {
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
    authBaseUrl() {
      return this.$store.getters.authBaseUrl;
    },
  },
  methods: {
    removePermittedUser(phNumber) {
      Swal.fire({
        title: 'ایا مطمئن هستید؟',
        text: "لطفاً دقت کنید در صورت حذف این شماره، کاربر مربوطه قادر به دسترسی به این کسب و کار نخواهد بود",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
        cancelButtonText: 'لغو',
        confirmButtonText: 'بلی، حذف شود',
      }).then((result) => {
          if (result.isConfirmed) {


  const loader = this.$loading.show();

      let body = {
        userPhoneNumber: phNumber,
      };
      merchantRepository()
        .removeUserToMerchantPermittedUser(
          this.merchantId,
          body,
          this.merchantBaseUrl
        )
        .then(() => {
          const index = this.permittedList.indexOf(phNumber);
          if (index > -1) {
            this.permittedList.splice(index, 1);
          }
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => {
          loader.hide();
        });


            
          Swal.fire({
            title: 'حذف!',
            text: 'دسترسی این شماره حذف گردید',
            icon: 'success',
          });
        }
      });

    
    },
    getUserInfoByPhone(userPhone) {
      let params = {
        phoneNumber: userPhone,
      };
      const loader = this.$loading.show();
      authRepository()
        .getUserInfo(this.authBaseUrl, {}, params)
        .then((res) => {
          this.showUserInfo = true;
          this.userInfo = res.data;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    AddPermittedUserPhone() {
      const loader = this.$loading.show();

      const index = this.permittedList.indexOf(this.mobilePhoneNumber);
      if (index > -1) {
        alert('شماره تکراری است');
        loader.hide();
        return;
      }

      if (this.mobilePhoneNumber.length != 10) {
        Helper.handleErrors('شماره تلفن وارد شده معتبر نیست', this);
        loader.hide();
        return;
      }
      let body = {
        userPhoneNumber: this.mobilePhoneNumber,
      };
      merchantRepository()
        .addUserToMerchantPermittedUser(
          this.merchantId,
          body,
          this.merchantBaseUrl
        )
        .then((res) => {
          this.permittedList.push(this.mobilePhoneNumber);
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    eventTypeDisplayName(title) {
      if (this.eventTypeList.length) {
        let result = this.eventTypeList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    //
    //getUserToMerchantPermittedUser
    getPermittedUsersData() {
      const loader = this.$loading.show();
      merchantRepository()
        .getUserToMerchantPermittedUser(this.merchantId, this.merchantBaseUrl)
        .then((res) => {
          this.permittedList = res.data;
          console.log('permitted list');
          console.log(res.data);
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    getMerchantInformation() {
      const loader = this.$loading.show();
      this.$store
        .dispatch('getMerchantInformation')
        .then((data) => {
          this.userBusinessInformation = data;
          console.log('data');
          console.log(data);
        })
        .finally(() => {
          loader.hide();
        });
    },
    getSupplierInformation() {
      const loader = this.$loading.show();
      this.$store
        .dispatch('getSupplierInformation')
        .then((data) => {
          this.userBusinessInformation = data;
          this.ownerUserPhone = data.userPhone;
          console.log('data2');
          console.log(data);
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
};
</script>
